import { LocalStorage } from 'shared/library/use-local-storage/index';

const store: LocalStorage = {
  getItem: async (k: string) => localStorage.getItem(k),
  setItem: async (k: string, v: string) => localStorage.setItem(k, v),
  removeItem: async (k: string) => localStorage.removeItem(k),
};

export { store };
